// Shopify exposes clicks on this wallet host, including clicks inside PayPal's iframe.
// Only release our dialog once PayPal presents its outside overlay: a rejected cart or
// cancelled launch must keep its controls and errors visible. Keep the wallet laid out
// until PayPal finishes: display:none makes Shopify rebuild its SDK frame mid-handoff.
let stopWatching = () => {};

document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;

  const wallet = event.composedPath().find(
    (node) => node instanceof Element && node.matches('shopify-paypal-button')
  );
  if (!(wallet instanceof Element) || wallet.hasAttribute('disabled')) return;

  const quickAdd = wallet.closest('quick-add-dialog');
  const drawer = wallet.closest('theme-drawer');
  const dialog = wallet.closest('dialog');
  if (!dialog?.open || (!quickAdd && !drawer)) return;

  stopWatching();
  let activeOverlay;
  let restoreLayout = () => {};
  const observer = new MutationObserver(releaseOverlay);
  const timeout = window.setTimeout(stop, 30000);

  function stop() {
    observer.disconnect();
    clearTimeout(timeout);
    dialog.removeEventListener('close', stop);
    dialog.removeEventListener('beforetoggle', onReopen);
    window.removeEventListener('pagehide', stop);
    restoreLayout();
    restoreLayout = () => {};
  }

  function isVisible(frame) {
    const bounds = frame.getBoundingClientRect();
    return frame.isConnected && bounds.width > 0 && bounds.height > 0 && getComputedStyle(frame).visibility !== 'hidden';
  }

  function onReopen(event) {
    if (event.newState === 'open') stop();
  }

  function releaseOverlay() {
    if (activeOverlay) {
      if (!isVisible(activeOverlay)) stop();
      return;
    }
    if (!dialog.open) return stop();
    // PayPal's accessible overlay is a body-level frame, outside Shopify's closed wallet.
    const overlay = [...document.querySelectorAll('iframe[title="PayPal Checkout Overlay"]')].find((frame) => {
      return !dialog.contains(frame) && isVisible(frame);
    });
    if (!overlay) return;

    activeOverlay = overlay;
    clearTimeout(timeout);
    dialog.removeEventListener('close', stop);
    const display = getComputedStyle(dialog).display;
    const previous = ['display', 'visibility'].map((name) => [name, dialog.style.getPropertyValue(name), dialog.style.getPropertyPriority(name)]);
    const wasInert = dialog.inert;
    restoreLayout = () => {
      for (const [name, value, priority] of previous) {
        if (value) dialog.style.setProperty(name, value, priority);
        else dialog.style.removeProperty(name);
      }
      dialog.inert = wasInert;
    };
    dialog.style.setProperty('display', display, 'important');
    dialog.style.setProperty('visibility', 'hidden', 'important');
    dialog.inert = true;
    dialog.addEventListener('beforetoggle', onReopen);
    if (quickAdd && typeof quickAdd.closeDialog === 'function') quickAdd.closeDialog();
    else if (drawer && typeof drawer.close === 'function') drawer.close();
  }

  stopWatching = stop;
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'hidden'],
  });
  dialog.addEventListener('close', stop, { once: true });
  window.addEventListener('pagehide', stop, { once: true });
  releaseOverlay();
});
